<div class="vida-card" data-testid="vida-application-card">
  <div class="vida-card__header">
    <h4 class="vida-card__title">{{ 'project.linked-application.title' | translate }}</h4>
    <span class="vida-card__type" *ngIf="technologyType">
      {{ technologyTypeKey ? ('project.types.' + technologyTypeKey | translate) : technologyType }}
    </span>
  </div>
  <div class="vida-card__state-lga" *ngIf="state || lga" data-testid="vida-card-state-lga">
    <span *ngIf="state"><strong>{{ 'project.linked-application.state-label' | translate }}</strong>: {{ state }}</span>
    <span *ngIf="lga"><strong>{{ 'project.linked-application.lga-label' | translate }}</strong>: {{ lga }}</span>
  </div>


  <div class="vida-card__community"
       *ngFor="let community of communities; index as i; trackBy: trackByIndex">
    <div class="vida-card__community-row">
      <span class="vida-card__community-name">{{ 'project.linked-application.community-label' | translate }}: {{ community.name }}</span>
      <span class="vida-card__subsidy">
        {{ community.subsidyCode }} · {{ community.subsidyAmount | currency:'USD':'symbol':'1.0-2' }}
        {{ 'project.linked-application.per-connection' | translate }}
      </span>
    </div>
    <div class="vida-card__numbers">
      <span *ngIf="community.availableConnections !== null">
        {{ 'project.linked-application.available' | translate }}: {{ community.availableConnections }}
      </span>
      <span *ngIf="community.proposedConnections !== null">
        {{ 'project.linked-application.proposed' | translate }}: {{ community.proposedConnections }}
      </span>
    </div>

    <button type="button"
            class="vida-card__expander"
            [attr.data-testid]="'vida-settlements-toggle-' + i"
            (click)="toggle(i)">
      <span class="vida-card__caret" [class.vida-card__caret--open]="isExpanded(i)">&#9656;</span>
      {{ 'project.linked-application.settlements' | translate }} ({{ community.settlements.length }})
    </button>
    <!-- Fixed column widths so every community's settlement table aligns identically
         (dev-demo item 5); headers per the mockup. -->
    <table class="vida-card__settlements" *ngIf="isExpanded(i)">
      <thead>
        <tr>
          <th>{{ 'project.linked-application.settlement-name' | translate }}</th>
          <th>{{ 'project.linked-application.settlement-id' | translate }}</th>
          <th>{{ 'project.linked-application.state-lga' | translate }}</th>
          <th class="vida-card__settlements-num">{{ 'project.linked-application.available' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let settlement of community.settlements; trackBy: trackByIndex">
          <td>{{ settlement.name }}</td>
          <td>{{ settlement.id }}</td>
          <td>{{ settlement.state }}<ng-container *ngIf="settlement.lga"> / {{ settlement.lga }}</ng-container></td>
          <td class="vida-card__settlements-num">{{ settlement.availableConnections === null ? '' : settlement.availableConnections }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
